<template>
    <div class="flex flex-col xl:flex-row items-center gap-x-4">
        <div v-if="!isAdmin" class="text-sm md:text-lg font-bold whitespace-nowrap">
            <span class="hidden md:inline">Order</span> Total: {{ toCurrency(cartTotal) }}
        </div>

        <jet-button :href="route('checkout')" v-show="cartCount || isAdmin" class="mt-1 xl:mt-0">
            <div class="flex justify-between items-center gap-x-3">
                <img src="/images/icons/shopping-cart.svg" width="20" height="20" alt="Cart" />
                <p class="text-xs md:text-normal text-center leading-tight">Checkout  <span v-if="!isAdmin">({{ cartCount }})</span></p>
            </div>
        </jet-button>
    </div>
</template>

<script>
import UseCart from '@/Composables/UseCart';
import { usePage } from '@inertiajs/inertia-vue3'
import JetButton from '@/Jetstream/Button';
import UseUserAuth from '@/Composables/UseUserAuth';

export default {
    setup (props) {
        const { isAdmin } = UseUserAuth(usePage().props.value.user);
        const { cartTotal, cartCount } = 
            UseCart(
                usePage().props.value.user,
                usePage().props.value.activeCustomer ? usePage().props.value.activeCustomer.tax_exempt : 0
            );

        return {
            cartTotal,
            cartCount,
            isAdmin,
        }
    },

    components: {
        JetButton,
    }
}
</script>

<style>

</style>